import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const CheckSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <div
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg height="100px" width="100px" fill={color} xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
        <g>
          <line fill={color} x1="19.713" y1="55.055" x2="33.258" y2="68.6" />
          <path d="M92.059,19.7c-2.733-2.733-7.165-2.734-9.9,0L33.258,68.6L17.841,53.183c-2.734-2.732-7.166-2.733-9.899,0.001   c-2.734,2.733-2.734,7.165,0,9.899l20.367,20.366c1.367,1.366,3.158,2.05,4.95,2.05s3.583-0.684,4.95-2.05l53.85-53.85   C94.792,26.866,94.792,22.434,92.059,19.7z" />
        </g>
      </svg>
    </div>
  );
};

CheckSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '15px',
    height: '15px',
  },
};

export default CheckSVG;
